// import "xss";

let waterMark = {};
let xssLoaded = {};
let uitl = {};
Object.defineProperty(uitl, "xss", {
  get() {
    if (!window.filterXSS) {
      require("xss");
    }
    return window.filterXSS;
  },
  enumerable: true,
  configurable: true
});

function getWaterMark(
  text,
  {
    fontSize = 16,
    lineHeight,
    textAlpha = dsf.config.setting_public_watermark_text_alpha,
    color = "rgb(226, 226, 226)",
    angle = -20,
    margin = [50, 50]
  }
) {
  text = text || dsf.session.get("user_name") || "";
  text = _.trim(text);
  if (!waterMark[text]) {
    let scale = 1;
    fontSize = fontSize / scale;
    lineHeight = lineHeight || Math.round(fontSize * 1.25);
    angle = (angle * Math.PI) / 180;
    let texts = text.split(/\r|\n|\r\n/g);
    var can = document.createElement("canvas");
    var cans = can.getContext("2d");
    let rect = getTextRect(cans, angle, fontSize, lineHeight, texts);
    can.width = rect.w + margin[1] * 2;
    can.height = rect.h + margin[0] * 2;
    cans.save();
    cans.translate(rect.w / 2 + margin[1], rect.h / 2 + margin[0]);
    cans.rotate(angle);
    cans.scale(scale, scale);
    cans.translate(-rect.w / 2, -rect.h / 2);
    cans.font = `${fontSize}px Microsoft YaHei`;
    cans.fillStyle = color;
    cans.textAlign = "center";
    cans.textBaseline = "hanging";
    cans.globalAlpha = textAlpha || 0.7;
    let x = rect.ow / 2;
    let y = rect.ot;
    for (let i = 0; i < texts.length; i++) {
      cans.fillText(texts[i], x, y + i * lineHeight);
    }
    cans.restore();
    waterMark[text] = {
      base64: can.toDataURL("image/png"),
      width: rect.w + margin[1] * 2,
      height: rect.h + margin[0] * 2
    };
    cans = can = undefined;
  }
  return waterMark[text];
}

/**
 * 计算文字所占矩形
 * @param cans
 * @param angle
 * @param fontSize
 * @param lineHeight
 * @param texts
 * @returns {{ot: number, w: number, ow: number, h: number}}
 */
function getTextRect(cans, angle, fontSize, lineHeight, texts) {
  cans.font = `${fontSize}px Microsoft YaHei`;
  cans.textAlign = "center";
  let points = [],
    height = 0;
  for (let i = 0; i < texts.length; i++) {
    let w = cans.measureText(texts[i]).width;
    let y1 = height,
      y2 = (height += lineHeight);
    let x2 = w / 2,
      x1 = -x2;
    points.push([x1, y1], [x2, y1], [x2, y2], [x1, y2]);
  }
  let ox1 = 0,
    ox2 = 0;
  let x1 = 0,
    x2 = 0,
    y1 = 0,
    y2 = 0;
  _.each(points, (p) => {
    ox1 = Math.min(ox1, p[0]);
    ox2 = Math.max(ox2, p[0]);
    p = rotatePoint(p[0], p[1], angle);
    x1 = Math.min(x1, p.x);
    x2 = Math.max(x2, p.x);
    y1 = Math.min(y1, p.y);
    y2 = Math.max(y2, p.y);
  });
  let ow = ox2 - ox1;
  let ot = (rotatePoint(ow / 2, 0, angle).y - y1 - lineHeight + fontSize) / 2;
  return {
    ot,
    ow,
    w: x2 - x1,
    h: y2 - y1
  };
}

/**
 * 将一个点绕原点旋转angle度后，
 * 计算新的点的坐标
 * @param x
 * @param y
 * @param angle
 */
function rotatePoint(x, y, angle) {
  const a = Math.sqrt(x * x + y * y);
  const r1 = Math.atan2(x, y);
  const r2 = angle + r1;
  return {
    x: a * Math.sin(r2),
    y: a * Math.cos(r2)
  };
}

function passwordEncode(pwd) {
  let encodeMode = dsf.config.setting_public_password_encode;
  if (encodeMode == "double-md5") {
    return dsf.md5(dsf.md5(pwd));
  } else if (encodeMode == "md5") {
    return dsf.md5(pwd);
  } else if (encodeMode == "sm2") {
    return dsf.sm2.encode(pwd, dsf.config.setting_public_smpublickey);
  }
}

//xss过滤白名单
let whiteList = {
  a: ["target", "href", "title"],
  abbr: ["title"],
  address: [],
  area: ["shape", "coords", "href", "alt"],
  article: [],
  aside: [],
  audio: ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"],
  b: [],
  bdi: ["dir"],
  bdo: ["dir"],
  big: [],
  blockquote: ["cite"],
  br: [],
  caption: [],
  center: [],
  cite: [],
  code: [],
  col: ["align", "valign", "span", "width"],
  colgroup: ["align", "valign", "span", "width"],
  dd: [],
  del: ["datetime"],
  details: ["open"],
  div: [],
  dl: [],
  dt: [],
  em: [],
  figcaption: [],
  figure: [],
  font: ["color", "size", "face"],
  footer: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  header: [],
  hr: [],
  i: [],
  img: ["src", "alt", "title", "width", "height"],
  ins: ["datetime"],
  li: [],
  mark: [],
  nav: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  section: [],
  small: [],
  span: [],
  sub: [],
  summary: [],
  sup: [],
  strong: [],
  strike: [],
  table: ["width", "border", "align", "valign"],
  tbody: ["align", "valign"],
  td: ["width", "rowspan", "colspan", "align", "valign"],
  tfoot: ["align", "valign"],
  th: ["width", "rowspan", "colspan", "align", "valign"],
  thead: ["align", "valign"],
  tr: ["rowspan", "align", "valign"],
  tt: [],
  u: [],
  ul: [],
  video: [
    "autoplay",
    "controls",
    "crossorigin",
    "loop",
    "muted",
    "playsinline",
    "poster",
    "preload",
    "src",
    "height",
    "width"
  ],
  svg: ["viewBox", "xmlns", "width", "height"]
};

for (var i in whiteList) {
  whiteList[i].unshift("style", "class", "id", "contenteditable");
}

let r_url = /^(http|https|ftp|ws|wss|\*):\/\/([.\w\-]+|\*)(:(\d{1,5}|\*))?/g;
function filterUrl(urlStr) {
  if (urlStr) {
    if (urlStr.startsWith("javascript:")) {
      return "";
    } else {
      if (
        urlStr.startsWith("http://") ||
        urlStr.startsWith("https://") ||
        urlStr.startsWith("//")
      ) {
        let currUrlInfo = dsf.url.parse(window.location.href);
        if (urlStr.startsWith("//")) {
          urlStr = currUrlInfo.protocol + urlInfo;
        }
        let urlInfo = dsf.url.parse(urlStr);
        // let protocol = currUrlInfo.protocol;
        let result = _.find(dsf.config.setting_public_whitelist || [], (it) => {
          r_url.lastIndex = 0;
          let u = r_url.exec(it["setting_public_white_list.domain"]);
          let protocol = u[1];
          let host = u[2];
          let port = u[4] || "";
          if (protocol != "*" && urlInfo.protocol != protocol + ":") {
            return false;
          }
          if (host != "*" && urlInfo.hostname != host) {
            return false;
          }
          if (port != "*" && urlInfo.port != port) {
            return false;
          }
          return true;
        });
        if (!result || result.length <= 0) {
          return "";
        } else {
          return urlStr;
        }
      }
      return urlStr;
    }
  }
}

function filterXSS(html, options) {
  if (dsf.isUnDef(html)) {
    return "";
  } else if (!dsf.isString(html)) {
    html = "" + html;
  }
  var defaultOptions = {
    whiteList: whiteList,
    onTagAttr(tag, name, value) {
      // style存在line-height: 4em; 会被过滤掉
      if (name == "style" && value) {
        return `${name}=\"${value}\"`;
      }
      //拦截输出字符串，必须对src、href特殊判断，否则src、href的值默认会被过滤
      if (name == "src" || name == "href") {
        if (tag == "iframe") {
          let url = filterUrl(value);
          if (url) {
            return `${name}=\"${value}\"`;
          } else {
            return `${name}`;
          }
        }
        if (value && value.trim().startsWith("javascript:")) {
          return `${name}`;
        } else {
          return `${name}=\"${value}\"`;
        }
      }
    }
  };
  let opts = dsf.mix(true, {}, defaultOptions, options || {});
  if (options?.overrideWhiteList) {
    if (dsf.isFunction(options.overrideWhiteList)) {
      opts.whiteList = options.overrideWhiteList(opts.whiteList);
    } else if (dsf.isObject(options.overrideWhiteList)) {
      opts.whiteList = options.overrideWhiteList;
    } else {
      opts.whiteList = whiteList;
    }
  }
  return uitl.xss(html, opts);
}

let obj = {
  getWaterMark,
  passwordEncode
  // xss: filterXSS,
  // url: filterUrl
};

Object.defineProperty(obj, "url", {
  value: filterUrl,
  writable: false
});
Object.defineProperty(obj, "xss", {
  value: filterXSS,
  writable: false
});

export default obj;
